import { FormControl as _FormControl, Paper as _Paper, styled, Typography } from '@mui/material'

export const Paper = styled(_Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1),
}))

export const IdText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  [theme.breakpoints.up('sm')]: {
    display: 'block',
  },
})) as typeof Typography

export const FormControl = styled(_FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 200,
  width: '90%',
}))
